function TypeException(message) {
  this.message = message;
  this.name = 'TypeException';
}

export default TypeException;
